<template>
  <el-row>
    <b v-if="row.name">
      <span>{{ row.name }}</span>
      <small v-if="row.storehouseCode" class="left-pad">{{ row.storehouseCode | dictText("Storehouse") }}</small>
    </b>
    <!-- <el-row v-if="!row.id">
      <el-button size="small" type="primary" icon="el-icon-plus" class="left-pad edit-input" @click="create">中草药医嘱</el-button>
    </el-row> -->
    <el-row>
      <el-row>
        <span v-for="v in row.items" :key="v.id" type="info" class="right-pad bottom-pad" size="small" hit>
          {{ v.name }}
          <b class="danger">{{ v.quantity }}</b>
          <span v-if="v.detailObj">{{ v.detailObj.unit }}</span>
          <b v-if="v.usage" class="danger">{{ v.usage | dictText("HerbalSpecialUsage") }}</b>
        </span>
      </el-row>
      <el-tag v-if="row.id" type="info" hit style="border-left: #67c23a 40px solid" class="top-pad">
        <span style="margin: 0 10px 0 -40px; color: white">草药</span>
        <span class="left-pad">
          <b class="danger">{{ row.makeMethod | dictText("HerbalMakeMethod") }}</b>
        </span>
        <span v-if="row.dosagePerTime" class="left-pad">
          <b class="danger">{{ row.dosagePerTime }}ml</b>
        </span>
        <span class="left-pad">
          <b class="danger">{{ row.usage | dictText("HerbalUsage") }}</b>
        </span>
        <span class="left-pad">
          <b class="danger">{{ row.frequency | dictText("HerbalFrequency") }}</b>
        </span>
        <span class="left-pad" v-if="row.ifMake">
          <el-tag type="danger" size="mini" effect="dark" hit>代煎</el-tag>
        </span>
      </el-tag>
      <el-button v-if="!readonly" type="primary" circle plain size="mini" icon="el-icon-edit" class="left-pad" @click="edit" />
    </el-row>
    <hic-herbal-dialog :visible.sync="showDlg" v-model="herbal" :new-item-fun="newItem" @ok="ok" />
  </el-row>
</template>
<script>
  import { mapGetters } from "sw-hic";
  import api from "../api";
  export default {
    props: {
      row: Object,
      readonly: Boolean,
    },
    data() {
      return {
        showDlg: false,
        herbal: {},
      };
    },
    computed: {
      ...mapGetters(["user", "treatment", "patient", "dict", "setting", "Enum", "diagnosis"]),
    },
    watch: {
      row(newVal) {
        this.getHerbal();
      },
    },
    mounted() {
      this.getHerbal();
    },
    inject: ["proto"], // 注入父类方法
    methods: {
      getHerbal() {
        if (!this.row || !this.row.id) {
          return;
        }
        // api.Advice.Herbal.get(this.row.id).then((res) => {
        //   try {
        //     res.items.forEach((item) => {
        //       this.$set(item, "detailObj", JSON.parse(item.detail));
        //     });
        //     this.$set(this.row, "items", res.items);
        //     console.log('this.row==', this.row)
        //   } catch (error) {

        //   }

        // });
        this.row.items.forEach((item) => {
          this.$set(item, "detailObj", JSON.parse(item.detail));
        });
      },
      newItem(opt) {
        let item = this.proto(opt);
        item.rpClass = "草药";
        return item;
      },
      // 回车获取焦点
      nextInput(e) {
        let inputs = document.getElementsByTagName("input");
        for (let i = 0; i < inputs.length; i++) {
          if (i == inputs.length - 1) {
            inputs[0].focus();
            inputs[0].select();
            break;
          } else if (e?.srcElement == inputs[i]) {
            inputs[i + 1].focus();
            inputs[i + 1].select();
            break;
          }
        }
      },
      create() {
        this.herbal = this.newItem();
        this.showDlg = true;
      },
      edit() {
        this.herbal = this.$utils.Obj.clone(this.row);
        this.herbal.dosageUnit = "";
        this.showDlg = true;
      },
      ok(data) {
        console.log("草药的数据:", data);
        api.Advice.Herbal.save(data).then((res) => {
          this.$message.success("操作成功");
          this.$emit("init");
        });
      },
      // ok(herbal) {
      //   api.AdviceHerbal.save(herbal).then((res) => {
      //     res.detailObj = JSON.parse(res.detail);
      //     res.items.forEach((i) => {
      //       i.detailObj = JSON.parse(i.detail);
      //     });
      //     if (herbal.id) {
      //       this.$emit("modified", res);
      //     } else {
      //       this.$emit("created", res);
      //     }
      //   });
      // },
    },
  };
</script>
